
<body>
  <a href="#" id="toTopBtn" class="cd-top text-replace js-cd-top cd-top--is-visible cd-top--fade-out" data-abc="true"></a>
  <app-header></app-header>
  <app-nav-menu></app-nav-menu>
  <app-sidenav-menu></app-sidenav-menu>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</body>
